import { RouteBasedSelectedProductTag } from "@lending/components/SelectedProductTag/RouteBasedSelectedProductTag";
import styles from "./PageHeader.module.css";

interface PageHeaderProps {
  heading: string;
  subheading: string;
}

function PageHeader({ heading, subheading }: PageHeaderProps) {
  return (
    <div className={styles.container}>
      <RouteBasedSelectedProductTag />
      <h1 className={styles.heading}>{heading}</h1>
      <div className={styles.subheading}>{subheading}</div>
    </div>
  );
}

export { PageHeader };
